<div>
  <textarea
    #markdownEditorContainer
    [attr.aria-label]="accessibleLabel"
    [attr.title]="accessibleLabel"
    [attr.placeholder]="placeholder || 'Markdown editor'"
  ></textarea>
</div>
